import styled from 'styled-components'
import { Card, Col, Flex, Row } from 'antd'

const BoardColumn = styled(Col)`
  display: flex;
  flex-direction: column;
  max-width: 12rem;
  min-width: 7rem;
  width: 100%;
  min-height: 100%;
  background-color: white;
  &:nth-child(odd) {
    background-color: ${props => props.theme.lightGray} !important;
  }
`
const BoardHeader = styled(Row)`
  padding: 0.5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: inherit;
  .board-header-title {
    font-size: 0.75rem;
    font-weight: 700;
    white-space: nowrap;
  }
  .board-header-quantity {
    font-size: 0.6rem;
    color: ${props => props.theme.primaryColor};
  }
`
const BoardContent = styled(Row)`
  padding: 0.5rem;
  border-radius: 0.5rem;
  padding: 0;
  overflow-y: auto;
  /* width */
  ::-webkit-scrollbar {
    width: 0.25rem;
    height: 0rem;
  }
  /* Track */
  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 0.25rem ${props => props.theme.lightGray};
    border-radius: 0.25rem;
  }
  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: ${props => props.theme.gray};
    border-radius: 10px;
    height: 4rem;
  }
  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: ${props => props.theme.darkGray};
  }
`
const StyledRequestCard = styled(Card)`
  width: 100%;
  min-height: 2rem;
  height: fit-content;
  border-radius: 0.125rem;
  margin: 0.25rem 0.25rem 0.25rem 0.25rem;
  border: unset;
  border-radius: 0.25rem;
  box-shadow: 0px 0px 3px 0px ${props => props.theme.secondaryDarkGray} !important;
  overflow: hidden;
  flex-direction: column;
  font-weight: 400;
  cursor: pointer;
  .ant-card-body {
    .ant-typography {
      line-height: 0.75rem;
      font-size: 0.7rem;
      overflow-wrap: break-word;
      word-break: unset;
    }
    padding: 0.5rem;
  }
  &:last-child {
    margin-bottom: 3rem;
  }
  &.canceled {
    background-color: ${props => props.theme.redCardCanceled} !important;
    .card__header svg {
      fill: ${props => props.theme.statusRed};
    }
  }
  &.no-show {
    background-color: ${props => props.theme.lightGray} !important;
    .card__header svg {
      fill: ${props => props.theme.lightBlack};
    }
  }
`

const CardRow = styled(Flex)`
  display: flex;
  margin: 0.5rem 0;
  &.card__header {
    justify-content: space-between;
    margin: 0rem 0rem 0.5rem 0rem !important;
    .CREATED {
      position: absolute;
      top: -0.75rem;
      left: -0.75rem;
      width: 1.5rem;
      height: 1.5rem;
      transform: rotate(45deg);
      background-color: orange !important;
    }
    input {
      cursor: pointer;
    }
    .PENDING {
      height: 0.75rem;
      width: 0.75rem;
      border-radius: 50%;
      position: relative;
      box-shadow: 0px 0px 2px 1px inset ${props => props.theme.darkGray};
      &.yellow {
        background-color: ${props => props.theme.status.yellow} !important;
      }
      &.green {
        background-color: ${props => props.theme.status.green} !important;
      }
      &.red {
        animation: pulse 2s infinite;
        background-color: ${props => props.theme.status.red} !important;
      }
      &.gray {
        background-color: ${props => props.theme.lightGray} !important;
      }
      &.expired {
        display: none;
      }
      @-webkit-keyframes pulse {
        0% {
          -webkit-box-shadow: 0 0 0 0 #e1394d41;
        }
        70% {
          -webkit-box-shadow: 0 0 0 0.5rem #e1394d00;
        }
        100% {
          -webkit-box-shadow: 0 0 0 0 #e1394d00;
        }
      }
      @keyframes pulse {
        0% {
          -moz-box-shadow: 0 0 0 0 #e1394d41;
          box-shadow: 0 0 0 0 #e1394d41;
        }
        70% {
          -moz-box-shadow: 0 0 0 0.5rem #e1394d00;
          box-shadow: 0 0 0 0.5rem #e1394d00;
        }
        100% {
          -moz-box-shadow: 0 0 0 0 #e1394d00;
          box-shadow: 0 0 0 0 #e1394d00;
        }
      }
    }
  }
  &.card__content {
    line-height: 0.65rem !important;
    flex-wrap: nowrap;
    .item {
      margin-right: 0.125rem;
    }
    .scrap-green {
      color: ${props => props.theme.scrapGreen} !important;
    }
  }
  .card__withdrawal-info {
    font-weight: 700;
  }
`
export { BoardColumn, BoardHeader, BoardContent, StyledRequestCard, CardRow }
